import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./font.css";
import App from "./App";
import ContextProvider from "./context";
import { SnackbarProvider } from "notistack";

ReactDOM.render(
  <React.StrictMode>
    <ContextProvider>
      <SnackbarProvider>
        <App />
      </SnackbarProvider>
    </ContextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
